module.exports = __webpack_public_path__ + "img/signlogo.1ae4de8e.png";